<!--
Copyright (c) 2025-2026, NVIDIA CORPORATION.  All rights reserved.

NVIDIA CORPORATION and its licensors retain all intellectual property
and proprietary rights in and to this software, related documentation
and any modifications thereto.  Any use, reproduction, disclosure or
distribution of this software and related documentation without an express
license agreement from NVIDIA CORPORATION is strictly prohibited.
-->

<!-- Copied from ui/projects/igo/src/app/shared/components/nv-rotary/nv-rotary.component.html -->
<div
    #button
    class="rotary-container"
    [class.disabled]="disabled"
    [attr.aria-disabled]="disabled ? true : null"
    (keydown.arrowleft)="goLeft($event)"
    (keydown.arrowright)="goRight($event)"
    [attr.aria-label]="computedAriaLabel"
    [attr.tabindex]="disabled ? -1 : 0"
    cdkMonitorElementFocus
>
    <div class="button-container">
        <button
            mat-icon-button
            class="rounded-button font-body2"
            [disabled]="disabled"
            (click)="goLeft($event)"
            [attr.aria-label]="leftButtonAriaLabel || null"
            tabindex="-1"
        >
            <mat-icon class="rotary-chevron" svgIcon="chevron_left"></mat-icon>
        </button>
    </div>
    <div #container class="nv-rotary-data-container item-width" aria-hidden="true">
        <div #items fxLayout="row" fxLayoutAlign="start center">
            @for (item of displayList; track item) {
                <div
                    class="font-body2 font-color-primary item-width"
                    [class.disabled-opacity]="disabled"
                    [class.selected]="item === input?.[selectedIndex]"
                    [class.truncate-text]="truncateText"
                    nvEllipsifiedTextWithTooltip
                    [applyEllipsisStyles]="applyEllipsisStyles"
                    [isTooltipEnabled]="truncateText"
                    tooltipClass="mat-tooltip-font-body3"
                    fxFlex="none"
                >
                    {{ item | translate }}
                </div>
            }
        </div>
    </div>
    <div class="button-container">
        <button
            mat-icon-button
            class="rounded-button font-body2"
            [disabled]="disabled"
            (click)="goRight($event)"
            [attr.aria-label]="rightButtonAriaLabel || null"
            tabindex="-1"
        >
            <mat-icon class="rotary-chevron" svgIcon="chevron_right"></mat-icon>
        </button>
    </div>
</div>
